module.exports = __webpack_public_path__ + "static/media/prune.e9f90f09.png";